import {useEffect, useState, useMemo} from "react";
import {useHistory} from "react-router-dom";
import {Formik} from "formik";

import {useAddNewProductMutation} from "./productSlice";
import {Input, TextArea} from "../../app/form/fields";
import FormCard from "../../app/card/FormCard";
import ButtonSpinner from "../../app/spinners/ButtonSpinner";
import {ProductSchema} from "./ProductSchema";
import {Message} from "../../app/index";
import {DraftProduct} from "../api";


export const AddProductForm = () => {
    const [message, setMessage] = useState<Message | null>(null);
    const [addNewProduct] = useAddNewProductMutation();
    const history = useHistory();
    const initialValues: DraftProduct = {
        name: "", unitCost: "", quantity: "", description: "", productId: ""
    }

    useEffect(() => {
        if (message?.type && message?.message) {
            window.scrollTo(0, 0);
        }
    }, [message?.type, message?.message])

    const form = (
        <Formik
            initialValues={initialValues}
            validationSchema={ProductSchema}
            onSubmit={async (values, actions) => {
                if (values.description === "") { delete values.description; }
                try {
                    const {product, error, invalidData} = await addNewProduct(values).unwrap();
                    actions.setSubmitting(false);
                    if (product) {
                        const message = { type: "success", message: "Product created successfully" }
                        history.push({
                            pathname: "/products",
                            state: { message }
                        });
                    }
                    if (error) { setMessage({ type: "danger", message: error }) }
                    if (invalidData) {
                        actions.setErrors(invalidData);
                        setMessage({ type: "danger", message: "Please correct the errors below" });
                    }
                } catch (error: any) {
                    setMessage({ type: "danger", message: error?.message });
                }
            }}
        >
            {props => (
                <>
                    <form onSubmit={props.handleSubmit}>
                        <Input name="name" label="Name" type="text" placeholder="Enter product name" required={true} />
                        <Input name="productId" label="Product ID" type="text" placeholder="Enter product id" required={false} />
                        <Input name="unitCost" label="Unit cost" type="number" placeholder="Enter product unit cost" required={true} />
                        <Input name="quantity" label="Quantity" type="number" placeholder="Enter product quantty" required={true} />
                        <TextArea name="description" label="Description" placeholder="Enter a description for the product" />

                        <button
                            type="submit"
                            className="btn btn-primary rounded-0 me-2 mt-3"
                            disabled={props.isSubmitting}
                        >
                            {props.isSubmitting ? <ButtonSpinner text="Adding" /> : "Add"}
                        </button>
                    </form>
                </>
            )}
        </Formik>
    );

    return ( <FormCard title="Add Product" message={message} setMessage={setMessage} cardBody={form} /> )
}
